import spotifyImg from '../assets/spotify.png';
import volvoImg from '../assets/volvo.png';
import styled from 'styled-components';
import { colors } from '../GlobalStyles';

const ClientsContainer = styled.section`
  background: ${colors.lightBeige};
  padding: 4rem 2rem;
  text-align: center;

  @media (max-width: 768px) {
    padding: 3rem 1rem;
  }
`;

const SectionTitle = styled.h2`
  font-size: 2rem;
  color: ${colors.textDark};
  margin-bottom: 3rem;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 1.8rem;
    margin-bottom: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 1.6rem;
  }
`;

const LogosContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 3rem;
  max-width: 1000px;
  margin: 0 auto;

  @media (max-width: 768px) {
    gap: 2rem;
  }

  @media (max-width: 480px) {
    gap: 1.5rem;
  }
`;

const ClientLogo = styled.img`
  height: 4rem;
  width: auto;
  filter: grayscale(100%);
  opacity: 0.7;
  transition: all 0.3s ease;

  &:hover {
    filter: grayscale(0%);
    opacity: 1;
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    height: 3rem;
  }

  @media (max-width: 480px) {
    height: 2.5rem;
  }
`;

const LogoPlaceholder = styled.div`
  height: 4rem;
  width: 120px;
  background: ${colors.textGray};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.white};
  font-size: 0.8rem;
  font-weight: 600;
  text-align: center;
  filter: grayscale(100%);
  opacity: 0.7;
  transition: all 0.3s ease;

  &:hover {
    filter: grayscale(0%);
    opacity: 1;
    transform: scale(1.05);
    background: ${colors.accentOrange};
  }

  @media (max-width: 768px) {
    height: 3rem;
    width: 100px;
    font-size: 0.7rem;
  }

  @media (max-width: 480px) {
    height: 2.5rem;
    width: 80px;
    font-size: 0.6rem;
  }
`;

export function Customers() {
  return (
    <ClientsContainer>
      <SectionTitle>Trusted by Industry Leaders</SectionTitle>
      <LogosContainer>
        <ClientLogo src={spotifyImg} alt="Spotify" />
        <ClientLogo src={volvoImg} alt="Volvo Cars" />
        <LogoPlaceholder>Mattssons.com</LogoPlaceholder>
      </LogosContainer>
    </ClientsContainer>
  );
}
